import api from "@/assets/js/utils/api.js";

// ✅ SweetAlert2 公用方法
import {
  showError,
  showToast,
  showLoading,
  hideLoading,
} from "@/assets/js/utils/alertService.js";

export default {
  name: "LoginView",
  data() {
    return {
      form: {
        email: "", //  原本是 email，這邊改掉
        password: "",
        captcha: "",
        rememberMe: false,
      },
      errors: {
        email: "",
        password: "",
        captcha: "",
      },
      showPassword: false,
      captchaCode: "",
    };
  },
  mounted() {
    this.generateCaptcha();
  },
  methods: {
    togglePassword() {
      this.showPassword = !this.showPassword;
    },
    generateCaptcha() {
      // 生成隨機 4 位數字驗證碼
      this.captchaCode = Math.floor(1000 + Math.random() * 9000).toString();
    },
    refreshCaptcha() {
      this.generateCaptcha();
      this.form.captcha = "";
    },
    validateForm() {
      this.errors = {
        email: "", // 重置錯誤訊息
        password: "",
        captcha: "",
      };

      let isValid = true; // 預設通過

      if (!this.form.email) {
        this.errors.email = "請輸入信箱"; // 帳號必填
        isValid = false;
      } else if (this.form.email.length < 3) {
        this.errors.email = "信箱長度至少為 3 個字元"; // 長度檢查
        isValid = false;
      }

      if (!this.form.password) {
        this.errors.password = "請輸入密碼"; // 密碼必填
        isValid = false;
      }

      if (!this.form.captcha) {
        this.errors.captcha = "請輸入驗證碼"; // 驗證碼必填
        isValid = false;
      } else if (this.form.captcha !== this.captchaCode) {
        this.errors.captcha = "驗證碼錯誤"; // 驗證碼不符
        this.refreshCaptcha(); // 重刷驗證碼
        isValid = false;
      }

      return isValid; // 回傳驗證結果
    },

    getDeviceId() {
      // 可以用 localStorage 模擬裝置唯一 ID
      let id = localStorage.getItem("deviceId");
      if (!id) {
        id = "DEV-" + Math.random().toString(36).substring(2, 15);
        localStorage.setItem("deviceId", id);
      }
      return id;
    },
    async getClientIP() {
      try {
        const res = await fetch("https://api.ipify.org?format=json");
        const data = await res.json();
        return data.ip || "unknown";
      } catch {
        return "unknown";
      }
    },
    async handleLogin() {
      if (!this.validateForm()) {
        return; // 驗證失敗中止流程
      }

      showLoading("登入中，請稍候..."); // 顯示 Loading 動畫

      try {
        const response = await api.post("/front/customer/login", {
          email: this.form.email,
          password: this.form.password,
          ip: await this.getClientIP(),
        });

        hideLoading(); // 登入成功/失敗後關閉 Loading

        if (response.data.success) {
          showToast("登入成功");

          if (response.data.token) {
            const token = response.data.token; // 取得 Token
            const expires = new Date(Date.now() + 60 * 60 * 1000).toUTCString(); // 1 小時後過期

            document.cookie = `token=${token}; expires=${expires}; path=/; secure; samesite=strict`;
            // 寫入 Cookie
          }

          this.$router.push("/").then(() => {
            window.location.reload(); // 跳轉首頁後重新整理
          });
        } else {
          showError(response.data.message || "登入失敗，請檢查帳號或密碼");
          // 顯示自訂錯誤訊息
        }
      } catch (error) {
        hideLoading(); // 錯誤發生關閉 Loading

        showError(
          error.response?.status === 403
            ? "此帳號已被鎖定"
            : error.response?.status === 401
            ? "帳號或密碼錯誤"
            : error.response?.data?.message || "伺服器錯誤，請稍後再試"
        ); // 顯示後端錯誤訊息

        this.refreshCaptcha(); // 刷新驗證碼
      }
    },

    async handleGoogleLogin() {
      try {
        const res = await api.get("/oauth/google/auth-url?type=login");

        if (res.data?.success && res.data.authUrl) {
          window.location.href = res.data.authUrl; // 🔥 直接跳轉 Google
        } else {
          showError("無法取得 Google 登入連結");
        }
      } catch (err) {
        console.error("Google login error:", err);
        showError("Google 登入連線錯誤");
      }
    },

    async handleLineLogin() {
      try {
        const res = await api.get("/oauth/line/auth-url?type=login");

        if (res.data?.success && res.data.authUrl) {
          window.location.href = res.data.authUrl; // 🔥 直接跳轉 LINE 授權
        } else {
          showError("無法取得 LINE 登入連結");
        }
      } catch (err) {
        console.error("LINE login error:", err);
        showError("LINE 登入連線錯誤");
      }
    },
  },
};
